import { MapPin, Clock } from "lucide-react";
import { EncabezadoSeccion, Reveal } from "../../shared/motion";

export default function Eventos({ datos, seccion }) {
  const eventos = datos.eventos || [];
  if (eventos.length === 0) return null;

  return (
    <section className="we-seccion" aria-label={seccion.titulo}>
      <div className="we-seccion-interior">
        <EncabezadoSeccion etiqueta={seccion.etiqueta} titulo={seccion.titulo} testid="we-titulo-eventos" />
        <div className="we-eventos-lista">
          {eventos.map((ev, i) => (
            <Reveal key={ev.id || i} delay={i * 0.08}>
              <article className="we-evento" data-testid={`we-evento-${ev.id || i}`}>
                <span className="we-evento-numero">{String(i + 1).padStart(2, "0")}</span>
                <div>
                  <p className="we-evento-etiqueta">{ev.etiqueta}</p>
                  <h3 className="we-evento-nombre">{ev.lugar}</h3>
                  <p className="we-evento-detalle">
                    <MapPin strokeWidth={1.5} />
                    <span>{ev.direccion}</span>
                  </p>
                  <p className="we-evento-detalle">
                    <Clock strokeWidth={1.5} />
                    <span>{ev.horario}</span>
                  </p>
                  {ev.urlUbicacion && (
                    <a
                      className="we-boton"
                      href={ev.urlUbicacion}
                      target="_blank"
                      rel="noopener noreferrer"
                      data-testid={`we-boton-ubicacion-${ev.id || i}`}
                    >
                      <MapPin strokeWidth={1.5} />
                      {ev.textoBoton || "Cómo llegar"}
                    </a>
                  )}
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
